import { render, staticRenderFns } from "./SankeyEChart.vue?vue&type=template&id=c490105a"
import script from "./SankeyEChart.vue?vue&type=script&lang=js"
export * from "./SankeyEChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports